import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import { colors, fontFamilySize, px } from '../../../../../../../../contrib/ui';

export const TeeAssignationRowStyled = styled(Grid)`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-top: ${px(10)};
  justify-content: space-between;

  .sub-rows {
    padding: 0 !important;

    @media (max-width: 991px) {
      margin-bottom: ${px(15)};
    }

    &.name {
    }

    &.sex {
      & > div {
        width: 100%;
      }
    }

    &.inner {
      width: ${px(140)};
      max-width: ${px(140)};
      padding: 0 !important;

      .table-title {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .input-icon {
        display: none;
      }
    }

    &.sub-row-actions {
      justify-content: flex-end;
      button {
        margin: 0;
        width: ${px(32)};
        height: ${px(32)};
        min-height: 0;

        &:last-child {
          margin-left: ${px(10)};
        }
        svg {
          font-size: ${px(16)};
        }
      }
    }

    .input {
      margin-bottom: 0;

      .material-input {
        margin-top: 0 !important;

        input {
          height: inherit !important;
        }
      }
      .form-helper-text {
        display: none;
      }
    }
  }

  &.table-title {
    padding: 0 ${px(10)};
    margin-bottom: ${px(5)};
    display: flex;
    font-family: 'DINNextLTPro-Bold';
    font-size: ${px(16)};
    line-height: 1.63em;

    .table-title-name,
    .table-title-sex,
    .table-title-range {
      ${fontFamilySize('Medium', 14)};
      color: ${colors.grey9b};
      text-transform: uppercase;
    }
    .table-title-name {
    }
    .table-title-sex {
      text-align: left;
      padding-left: ${px(25)};
    }
    .table-title-range {
      text-align: center;
      margin-bottom: 0;
    }

    .table-title-actions {
    }

    &:after {
      /* Fake actions box */
      content: '';
      width: ${px(90)};
      display: block;
    }
  }

  &.items {
    border-radius: 5px;
    padding: ${px(10)};
    box-shadow: 0 0 15px 0 rgba(24, 31, 77, 0.15);
    height: ${px(60)};

    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;

    /* @media (max-width: 991px) {
      flex-direction: column;
      height: auto;
      align-items: start;
    } */

    @media (max-width: 991px) {
      flex-direction: column;
      height: auto;
      align-items: start;
    }

    .sub-rows {
      display: flex;
      flex-direction: row;
      justify-content: center;

      @media (max-width: 991px) {
        width: 100%;
      }

      &.name {
        min-width: px(234);
        max-width: px(234);
        width: px(234);

        .inner {
          width: 100%;
          max-width: 100%;
        }
      }

      &.age {
        min-width: px(140);
        max-width: px(140);
        width: px(140);
      }

      &.sex {
        min-width: px(112);
        max-width: px(112);
        width: px(112);
      }

      &.sub-row-actions {
        min-width: px(90);
        max-width: px(90);
        width: px(90);
      }

      &.handicaps {
        .autocomplete {
          width: 100%;
        }
      }

      &.name,
      &.sex,
      &.age,
      &.handicaps,
      &.sub-row-actions {
        @media (max-width: 991px) {
          min-width: 100%;
          max-width: 100%;
          width: 100%;
        }
      }

      .inner {
        width: 100%;

        .autocomplete-wrapper,
        .input-form-control {
          width: 100%;
        }
      }

      @media (max-width: 991px) {
        /* flex-shrink: 0; */
        width: 100%;
        max-width: 100%;
        margin-bottom: px(15);

        .inner {
          /* flex-grow: 1;
              max-width: auto; */
          width: 100%;

          .autocomplete-wrapper,
          .input-form-control {
            width: 100%;
          }

          i {
            display: align-block;
            text-align: center;
          }
        }

        label {
          @mixin font-family-size Medium, 14;
          color: var(--grey9b);
          margin-right: px(10);
          line-height: 3;

          display: inline-block;
          width: 100px;
        }
      }

      &.inner {
        padding-right: 0;
      }
    }
  }
`;
